import { render, staticRenderFns } from "./PosMenu.vue?vue&type=template&id=26f650b2&scoped=true"
import script from "./PosMenu.vue?vue&type=script&lang=js"
export * from "./PosMenu.vue?vue&type=script&lang=js"
import style0 from "./PosMenu.vue?vue&type=style&index=0&id=26f650b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f650b2",
  null
  
)

export default component.exports